export enum SetPasswordMode {
	password = 'password',
	registration = 'registration',
	expiration = 'expiration',
}